<div class="grid">
	<div class="col-12 pb-0">
		<div class="flex align-items-center justify-content-center p-1 border-round-xl"
			[class]="(deviceStatus?.Configured === 0) ? 'bg-green-200' : 'bg-yellow-200' ">
			<p-tag icon="pi cm-alert"
				[value]="(deviceStatus?.Configured === 0 ? 'MULTI_IO_CONFIGURED' : 'MULTI_IO_UNCONFIGURED') | translate"
				[severity]="deviceStatus?.Configured === 0 ? 'success' : 'warning' ">
			</p-tag>
		</div>
	</div>

	<div class="col-12" *ngIf="inputs && inputs.length > 0">
		<p-panel>
			<ng-template pTemplate="header">
				<div class="flex align-items-center">
					<span class="font-semibold">{{ 'STATE_INPUTS' | translate }}</span>
				</div>
			</ng-template>
			<div class="grid">
				<div [class]="onExtendedMobile() ? 'col-12' : 'col-6'" *ngFor="let input of inputs">
					<div class="flex align-items-center justify-content-around card border-round-2xl">
						<div>{{ 'IN ' + input.InputId }}</div>
						<div>
							<p-tag
								[value]="(deviceStatus.Inputs.get(input.InputId) !== undefined) ? deviceStatus.Inputs.get(input.InputId) : 0"
								[severity]="inputActive(input)  ? 'success' : 'danger'"></p-tag>
							<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}" class="pl-2"
								(click)="editInput(input)" *ngIf="owned" [text]="true" severity="secondary"
								styleClass="font-bold">
							</p-button>
						</div>
					</div>
				</div>
			</div>
		</p-panel>
	</div>

	<div class="col-12" *ngIf="outputs && outputs.length > 0">
		<p-panel>
			<ng-template pTemplate="header">
				<div class="flex align-items-center">
					<span class="font-semibold">{{ 'STATE_OUTPUTS' | translate }}</span>
				</div>
			</ng-template>
			<div class="grid">
				<div [class]="onExtendedMobile() ? 'col-12' : 'col-6'" *ngFor="let output of outputs">
					<div class="flex align-items-center justify-content-around card border-round-2xl">
						<div>{{ 'OUT ' + output.OutputId }}</div>
						<div>
							<p-tag
								[value]="(deviceStatus.Outputs.get(output.OutputId) !== undefined) ? deviceStatus.Outputs.get(output.OutputId) : 0"
								[severity]="outputActive(output)  ? 'success' : 'danger'"></p-tag>
							<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}" class="pl-2"
								(click)="editOutput(output)" *ngIf="owned" [text]="true" severity="secondary"
								styleClass="font-bold">
							</p-button>
						</div>
					</div>
				</div>
			</div>
		</p-panel>
	</div>
</div>